import { useState } from 'react';
import { useGoogleLogin as useGoogleLoginLib } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router';
import { getLoginErrorMessage } from '../utils/loginError';

export function useGoogleLoginCustom(onSubmitSuccess, setLoader) {
  const [error, setError] = useState(null);
  const { setProviderName, checkSession } = useAuth();
  const navigate = useNavigate();

  const login = useGoogleLoginLib({
    onSuccess: async (tokenResponse) => {
      try {
        const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = await userInfoResponse.json();

        const apiResponse = await fetch(window.API_URL + '/extranet/connexion/google', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            utilisateur: {
              email: userInfo.email,
              google_access_token: tokenResponse.access_token,
            },
          }),
        });

        if (!apiResponse.ok) {
          setError(await getLoginErrorMessage(apiResponse, 'Erreur lors de la connexion avec Google'));
          setLoader(false);
          return;
        }

        const apiData = await apiResponse.json();

        localStorage.setItem('client_id', apiData.client_id);
        localStorage.setItem('userName', userInfo.name);

        setProviderName('Google');
        await checkSession();
        navigate('/tickets');
      } catch (e) {
        console.error('Erreur connexion Google :', e);
        setError('Erreur lors de la connexion avec Google');
        setLoader(false);
      }
    },
    onError: () => {
      setError('Erreur lors de la connexion avec Google');
      setLoader(false);
    },
  });

  const handleGoogleLogin = () => {
    setError(null);
    login();
  };

  return { handleGoogleLogin, error };
}
